// src/config/templates.js
// Single source of truth for WhatsApp automation templates

/**
 * Centralized template definitions for automation system
 * Each template contains all necessary configuration for both frontend and backend
 */
export const AUTOMATION_TEMPLATES = {
  'bq_customer_request_update': {
    id: 'bq_customer_request_update',
    name: 'לקוח קבע לעצמו תור',
    description: 'הודעה המאשרת ללקוח שבקשתו לתור נקלטה',

    // WhatsApp Meta API Configuration
    whatsapp: {
      contentSid: 'HXd5a87466ffbb11dcbcc1da75178ccffb',
      messagingServiceSid: 'MG1dba625b34b04489b81ee5fe81d937e3'
    },

    // Variables in order (1-based indexing for Meta API)
    variables: [
      {
        name: 'customer_name',
        displayName: 'שם הלקוח',
        order: 1,
        source: 'customer_name'
      },
      {
        name: 'service_name',
        displayName: 'שם השירות',
        order: 2,
        source: 'service_name'
      },
      {
        name: 'business_name',
        displayName: 'שם העסק',
        order: 3,
        source: 'BUSINESS:business_name'
      }
    ],

    // Template content with variable placeholders
    content: `שלום {{1}},
ברצוננו לעדכן אותך שהתור שביקשת לקבוע ל{{2}}
בתאריך {{3}}
בשעה {{4}}
אושר ונקבע בהצלחה.`,

    // Associated trigger types - used when CUSTOMER schedules their own appointment
    triggerTypes: ['appointment_created'],

    // Default timing (not used for appointment_created)
    defaultTiming: null
  },

  'bg_customer_request_approved': {
    id: 'bg_customer_request_approved',
    name: 'תור נקבע',
    description: 'הודעה המאשרת ללקוח שתורו נקבע בהצלחה',

    // WhatsApp Meta API Configuration
    whatsapp: {
      contentSid: 'HX8d39f03cf4a0da37e9ed0392ab256404',
      messagingServiceSid: 'MG1dba625b34b04489b81ee5fe81d937e3'
    },

    // Variables in order (1-based indexing for Meta API)
    variables: [
      {
        name: 'customer_name',
        displayName: 'שם הלקוח',
        order: 1,
        source: 'customer_name'
      },
      {
        name: 'business_name',
        displayName: 'שם העסק',
        order: 2,
        source: 'BUSINESS:business_name'
      },
      {
        name: 'date',
        displayName: 'תאריך התור',
        order: 3,
        source: 'date',
        formatter: 'date'
      },
      {
        name: 'time',
        displayName: 'שעת התור',
        order: 4,
        source: 'time',
        formatter: 'time'
      }
    ],

    // Template content with variable placeholders
    content: `שלום {{1}},
ברצוננו לעדכן אותך שהתור שביקשת לקבוע ל{{2}}
בתאריך {{3}}
בשעה {{4}}
אושר ונקבע בהצלחה.`,

    // Associated trigger types - used when ADMIN schedules or approves appointment
    triggerTypes: ['appointment_approved'],

    // Default timing (not used for appointment_approved)
    defaultTiming: null
  },

  'bq_appointment_reminder': {
    id: 'bq_appointment_reminder',
    name: 'תזכורת לפני תור',
    description: 'הודעה שנשלחת 24 שעות לפני תור',

    whatsapp: {
      contentSid: 'HX5b68302ef102e987d7a2f39179c48855',
      messagingServiceSid: 'MG1dba625b34b04489b81ee5fe81d937e3'
    },

    variables: [

      {
        name: 'customer_name',
        displayName: 'Customer Name',
        order: 1,
        source: 'customer_name'
      },
      {
        name: 'service_name',
        displayName: 'שם השירות',
        order: 2,
        source: 'service_name'
      },
      {
        name: 'business_name',
        displayName: 'Business Name',
        order: 3,
        source: 'BUSINESS:business_name'
      },
      {
        name: 'date',
        displayName: 'Appointment Date',
        order: 4,
        source: 'date',
        formatter: 'date'
      },
      {
        name: 'time',
        displayName: 'Appointment Time',
        order: 5,
        source: 'time',
        formatter: 'time'
      },
      {
        name: 'business_location',
        displayName: 'Business Location',
        order: 6,
        source: 'BUSINESS:business_location'
      },
      {
        name: 'business_phone',
        displayName: 'Business Phone',
        order: 7,
        source: 'BUSINESS:business_phone'
      }
    ],

    content: `שלום {{1}}, זוהי תזכורת לתור שקבעת ל{{2}} אצל {{3}}.
בתאריך {{4}}
בשעה {{5}}
בכתובת {{6}}
במידה וחל שינוי, ניתן ליצור קשר במספר {{7}} בטלפון או בווטסאפ.
תודה.

`,

    triggerTypes: ['before_appointment'],
    defaultTiming: 24
  },

  // TODO: doesnt exist yet
  'bq_appointment_early_reminder': {
    id: 'bq_appointment_early_reminder',
    name: 'תזכורת מוקדמת לפני תור',
    description: 'תזכורת מוקדמת שנשלחת לפני תור (ניתן לשנות את הזמן)',

    whatsapp: {
      contentSid: '', // To be filled when template is created
      messagingServiceSid: 'MG1dba625b34b04489b81ee5fe81d937e3'
    },

    variables: [
      {
        name: 'customer_name',
        displayName: 'Customer Name',
        order: 1,
        source: 'customer_name'
      },
      {
        name: 'service_name',
        displayName: 'שם השירות',
        order: 2,
        source: 'service_name'
      },
      {
        name: 'business_name',
        displayName: 'Business Name',
        order: 3,
        source: 'BUSINESS:business_name'
      },
      {
        name: 'date',
        displayName: 'Appointment Date',
        order: 4,
        source: 'date',
        formatter: 'date'
      },
      {
        name: 'time',
        displayName: 'Appointment Time',
        order: 5,
        source: 'time',
        formatter: 'time'
      },
      {
        name: 'business_location',
        displayName: 'Business Location',
        order: 6,
        source: 'BUSINESS:business_location'
      },
      {
        name: 'business_phone',
        displayName: 'Business Phone',
        order: 7,
        source: 'BUSINESS:business_phone'
      }
    ],

    content: `שלום {{1}}, זוהי תזכורת מוקדמת לתור שקבעת ל{{2}} אצל {{3}}.
בתאריך {{4}}
בשעה {{5}}
בכתובת {{6}}
במידה וחל שינוי, ניתן ליצור קשר במספר {{7}} בטלפון או בווטסאפ.
תודה.

`,

    triggerTypes: ['before_appointment'],
    defaultTiming: 48
  },

//   'appointment_early_reminder': {
//     id: 'appointment_early_reminder',
//     name: 'תזכורת מוקדמת לפני תור',
//     description: 'תזכורת שנשלחת X שעות לפני תור (ניתן לשנות את הזמן)',

//     whatsapp: {
//       contentSid: 'HX0a7a9f41a5a9c7ab2ec3623005a3054d',
//       messagingServiceSid: 'MG1dba625b34b04489b81ee5fe81d937e3'
//     },

//     variables: [
//       {
//         name: 'business_name',
//         displayName: 'Business Name',
//         order: 1,
//         required: true,
//         source: 'BUSINESS:business_name'
//       },
//       {
//         name: 'customer_name',
//         displayName: 'Customer Name',
//         order: 2,
//         required: true,
//         source: 'customer_name'
//       },
//       {
//         name: 'date',
//         displayName: 'Appointment Date',
//         order: 3,
//         required: true,
//         source: 'date',
//         formatter: 'date'
//       },
//       {
//         name: 'time',
//         displayName: 'Appointment Time',
//         order: 4,
//         required: true,
//         source: 'time',
//         formatter: 'time'
//       },
//       {
//         name: 'crew_member_name',
//         displayName: 'Staff Member',
//         order: 5,
//         required: true,
//         source: 'crew_member_name'
//       },
//       {
//         name: 'business_location',
//         displayName: 'Business Location',
//         order: 6,
//         required: true,
//         source: 'BUSINESS:business_location'
//       },
//       {
//         name: 'business_phone',
//         displayName: 'Business Phone',
//         order: 7,
//         required: true,
//         source: 'BUSINESS:business_phone'
//       }
//     ],

//     content: `תזכורת תור מוקדמת - *{{1}}*

// היי {{2}} 👋
// זוהי תזכורת מוקדמת לתור שלך, במידה וחל שינוי אנא עדכן אותנו בהקדם האפשרי

// פרטי התור:
// 📅 תאריך: {{3}}
// 🕐 שעה: {{4}}
// 👤 עם: {{5}}
// 📍 מיקום: {{6}}

// פרטים ליצירת קשר:
// 📞 טלפון: {{7}}`,

//     triggerTypes: ['before_appointment'],
//     defaultTiming: 48
//   },

  'loginotp': {
    id: 'loginotp',
    name: 'וריפיקציה טלפונית',
    description: 'Phone verification code template',

    whatsapp: {
      contentSid: 'HXc231bbecb16fd756a3f41584439ecf92',
      messagingServiceSid: 'MG1dba625b34b04489b81ee5fe81d937e3'
    },

    variables: [
      {
        name: 'code',
        displayName: 'Verification Code',
        order: 1,
        required: true,
        source: 'code'
      }
    ],

    content: `קוד אימות: **{{code}}**`,

    triggerTypes: [], // Special system template
    defaultTiming: null
  }
};

/**
 * Utility functions for working with templates
 */

/**
 * Get all available templates
 * @returns {Object} All template configurations
 */
export function getAllTemplates() {
  return { ...AUTOMATION_TEMPLATES };
}

/**
 * Get template by ID
 * @param {string} templateId - Template identifier
 * @returns {Object|null} Template configuration or null if not found
 */
export function getTemplate(templateId) {
  return AUTOMATION_TEMPLATES[templateId] || null;
}

/**
 * Get templates by trigger type
 * @param {string} triggerType - Trigger type (before_appointment, after_appointment, appointment_created)
 * @returns {Array} Array of matching templates
 */
export function getTemplatesByTriggerType(triggerType) {
  return Object.values(AUTOMATION_TEMPLATES).filter(template =>
    template.triggerTypes.includes(triggerType)
  );
}

/**
 * Get default template for trigger type
 * @param {string} triggerType - Trigger type
 * @returns {Object|null} Default template for this trigger type
 */
export function getDefaultTemplate(triggerType) {
  const templates = getTemplatesByTriggerType(triggerType);
  return templates.length > 0 ? templates[0] : null;
}

/**
 * Generate template variable mapping for backend
 * @param {string} templateId - Template ID
 * @returns {Object} Variable mapping object
 */
export function buildTemplateVariableMapping(templateId) {
  const template = getTemplate(templateId);
  if (!template) {
    return {};
  }

  const mapping = {};
  template.variables.forEach(variable => {
    mapping[variable.name] = variable.source;
  });

  return mapping;
}

/**
 * Generate template preview with sample data
 * @param {string} templateId - Template ID
 * @param {Object} sampleData - Optional custom sample data
 * @returns {string} Preview text with variables replaced
 */
export function generateTemplatePreview(templateId, sampleData = null) {
  const template = getTemplate(templateId);
  if (!template) {
    return 'Template not found';
  }

  const defaultSampleData = {
    business_name: 'סיון מנדל אסתטיקה ויופי',
    customer_name: 'שרה כהן',
    date: 'יום שני, 15 בינואר',
    time: '14:30',
    crew_member_name: 'סיון',
    business_location: 'פתח תקווה, רחוב הרצל 123',
    business_phone: '050-6376699',
    code: '1234'
  };

  const data = sampleData || defaultSampleData;
  let preview = template.content;

  // Replace all variables
  template.variables.forEach(variable => {
    const placeholder = `{{${variable.name}}}`;
    const value = data[variable.name] || `[${variable.displayName}]`;
    preview = preview.replace(new RegExp(placeholder.replace(/[{}]/g, '\\$&'), 'g'), value);
  });

  return preview;
}

/**
 * Get WhatsApp API configuration for template
 * @param {string} templateId - Template ID
 * @returns {Object|null} WhatsApp configuration
 */
export function getWhatsAppConfig(templateId) {
  const template = getTemplate(templateId);
  return template ? template.whatsapp : null;
}

/**
 * Get ordered variables for template (for Meta API)
 * @param {string} templateId - Template ID
 * @returns {Array} Array of variable names in order
 */
export function getTemplateVariables(templateId) {
  let template = getTemplate(templateId);

  // If not found, try campaign templates
  if (!template) {
    template = getCampaignTemplate(templateId);
  }

  if (!template) {
    return [];
  }

  return template.variables
    .sort((a, b) => a.order - b.order)
    .map(v => v.name);
}

/**
 * Validate template configuration
 * @param {Object} templateConfig - Template configuration to validate
 * @returns {Object} Validation result with isValid and errors
 */
export function validateTemplate(templateConfig) {
  const errors = [];

  if (!templateConfig.id) {
    errors.push('Template ID is required');
  }

  if (!templateConfig.name) {
    errors.push('Template name is required');
  }

  if (!templateConfig.whatsapp?.contentSid) {
    errors.push('WhatsApp contentSid is required');
  }

  if (!templateConfig.variables || !Array.isArray(templateConfig.variables)) {
    errors.push('Template variables must be an array');
  }

  if (!templateConfig.content) {
    errors.push('Template content is required');
  }

  return {
    isValid: errors.length === 0,
    errors
  };
}

// Campaign-specific templates with user-defined variables
export const CAMPAIGN_TEMPLATES = {
  'campaign_long_time_no_see_1': {
    id: 'campaign_long_time_no_see_1',
    name: 'Long Time No See',
    description: 'Re-engagement message for inactive customers',

    whatsapp: {
      contentSid: 'HX5ac9b937b883cb762d1603329855e675',
      messagingServiceSid: 'MG1dba625b34b04489b81ee5fe81d937e3'
    },

    variables: [
      {
        name: 'business_name',
        displayName: 'Business Name',
        order: 1,
        inputType: 'auto',
        source: 'BUSINESS:business_name'
      },
      {
        name: 'customer_name',
        displayName: 'Customer Name',
        order: 2,
        inputType: 'auto',
        source: 'customer_name'
      },
      {
        name: 'discount_offer',
        displayName: 'Discount/Offer',
        order: 3,
        inputType: 'user',
        placeholder: 'e.g., 20% discount, free consultation',
        required: true
      },
      {
        name: 'business_id',
        displayName: 'Business ID',
        order: 4,
        inputType: 'auto',
        source: 'BUSINESS:business_id'
      }
    ],

    content: `מחכים לך ב{{1}}! היי {{2}}, רק מזכירים שאנחנו כאן בשבילך עם צוות מקצועי והטבה נעימה: *{{3}}*. אם מתאים לך, אפשר לקבוע תור בקלות דרך הכפתור.`
  }
};

/**
 * Get campaign templates
 * @returns {Object} Campaign template configurations
 */
export function getCampaignTemplates() {
  return { ...CAMPAIGN_TEMPLATES };
}

/**
 * Get campaign template by ID
 * @param {string} templateId - Template identifier
 * @returns {Object|null} Template configuration or null if not found
 */
export function getCampaignTemplate(templateId) {
  return CAMPAIGN_TEMPLATES[templateId] || null;
}

/**
 * Get user-defined variables for a template
 * @param {string} templateId - Template ID
 * @returns {Array} Array of user-defined variables
 */
export function getUserDefinedVariables(templateId) {
  const template = getCampaignTemplate(templateId);
  if (!template) return [];

  return template.variables
    .filter(v => v.inputType === 'user')
    .sort((a, b) => a.order - b.order);
}